'use strict';

/**
 * Model for saving the settings for the list view
 *
 * @category   Model
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var SettingsObjectListModel = require('modules/collection/models/settings-object-list');

var SetSettingsObjectListModel = SettingsObjectListModel.extend({
    storageKey: 'module:collection:sets:list',

    defaults: {
        id: 1,
        viewModeDefault: 'grid',
        sortGrid: 'name.asc',
        setModel: true,
    },

    validSortGridValues: [
        'name.asc',
        'itemCount.desc',
        'lastEdited.desc',
    ],
});

module.exports = SetSettingsObjectListModel;